import React from 'react';
import { Helmet } from 'react-helmet-async';
import { m } from 'framer-motion';
import { Story } from './Story';
import Footer from 'components/Footer/Footer';

import styles from './AdrianSanctuary.module.scss';

export const AdrianSanctuary = () => {
  return (
    <m.main
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      className="egg"
    >
      <Helmet>
        <title>Adrian&#39;s Sanctuary - Duskbreakers</title>
      </Helmet>

      <div className={styles.sanctuary}>
        <h1 className="heading-default">Adrian&#39;s Sanctuary</h1>
        <Story />
      </div>

      <Footer />
    </m.main>
  );
};
